/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminEbayPriceHint
 */
export interface AdminEbayPriceHint {
    /**
     * Floor is the lowest price that keeps the minimum net proceeds.
     * @type {number}
     * @memberof AdminEbayPriceHint
     */
    floor: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayPriceHint
     */
    marketCapturedAt?: string;
    /**
     * Reference is the market buyer total (comparable price + its shipping).
     * @type {number}
     * @memberof AdminEbayPriceHint
     */
    reference?: number;
    /**
     * Suggested is null without eBay market data for the product.
     * @type {number}
     * @memberof AdminEbayPriceHint
     */
    suggested?: number;
}

export function AdminEbayPriceHintFromJSON(json: any): AdminEbayPriceHint {
    return AdminEbayPriceHintFromJSONTyped(json, false);
}

export function AdminEbayPriceHintFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayPriceHint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'floor': json['floor'],
        'marketCapturedAt': !exists(json, 'marketCapturedAt') ? undefined : json['marketCapturedAt'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
        'suggested': !exists(json, 'suggested') ? undefined : json['suggested'],
    };
}

export function AdminEbayPriceHintToJSON(value?: AdminEbayPriceHint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'floor': value.floor,
        'marketCapturedAt': value.marketCapturedAt,
        'reference': value.reference,
        'suggested': value.suggested,
    };
}

